
import { BASE_URL } from "../../helpers/config";
import { showToast, showAlert } from "../../utils/helpers/ShowToast";
import { getReadableApiError } from "../../utils/helpers/apiError";
import authorizedAxios from "../../helpers/authorizedAxios";
export const SET_SUPPLIERS = "SET_SUPPLIERS";
export const SET_SUPPLIERS_LOADING = "SET_SUPPLIERS_LOADING";
export const SET_SUPPLIERS_ERROR = "SET_SUPPLIERS_ERROR";

export const fetchSuppliers = (limit = 100, page = 1, search = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_SUPPLIERS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/suppliers?limit=" + limit + "&page=" + page + "&search=" + search);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_SUPPLIERS,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SUPPLIERS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_SUPPLIERS_LOADING, status: false });
    }
  };
};

export const getSupplierById = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_SUPPLIERS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/suppliers/" + id);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_SUPPLIERS,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SUPPLIERS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_SUPPLIERS_LOADING, status: false });
    }
  };
};

export const addSupplier = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_SUPPLIERS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/suppliers`, data), {
        loading: "Menyimpan data...",
        success: "Data supplier berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data!"
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchSuppliers());
        return true;
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SUPPLIERS_ERROR,
        error: getReadableApiError(error, "Data supplier gagal disimpan.")
      });
      return false;
    } finally {
      dispatch({ type: SET_SUPPLIERS_LOADING, status: false });
    }
  };
};

export const updateSupplier = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_SUPPLIERS_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/suppliers/${id}`, data), {
        loading: "Mengupdate data...",
        success: "Data supplier berhasil diperbarui!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data!"
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchSuppliers());
        return true;
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SUPPLIERS_ERROR,
        error: getReadableApiError(error, "Data supplier gagal diperbarui.")
      });
      return false;
    } finally {
      dispatch({ type: SET_SUPPLIERS_LOADING, status: false });
    }
  };
};

export const deleteSupplier = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_SUPPLIERS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`${BASE_URL}/suppliers/${id}`), {
        loading: "Menghapus data...",
        success: "Data supplier berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data supplier berhasil dihapus!"
        });
        dispatch(fetchSuppliers());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SUPPLIERS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
    } finally {
      dispatch({ type: SET_SUPPLIERS_LOADING, status: false });
    }
  };
};
